import loadScript from '../util/loader';
import isTouch from '../util/touch';

const defaultOptions = {
  cc_load_policy: 1,
  iv_load_policy: 3,
  modestbranding: 1,
  playsinline: 1,
  controls: 1,
  showinfo: 0,
  ecver: 2,
  fs: 1,
  rel: 0,
};

export default function embedYoutube(uniqueKey, options) {
  const playerOptions = {
    ...defaultOptions,
    ...options,
  };
  const playerWrapper = document.querySelector(`[data-player="${uniqueKey}"]`);
  const playerElement = playerWrapper.querySelector('iframe, [data-replace]');
  const youtubeKey = playerWrapper.querySelector('[data-video-id]').getAttribute('data-video-id');
  loadScript({url: 'https://www.youtube.com/iframe_api'});
  const playerPromise = window.youtubeLoaderPromise
    .then(function () {
      let player = new window.YT.Player(playerElement, {
        videoId: youtubeKey,
        playerVars: {
          ...playerOptions,
        },
      });
      playerWrapper.addEventListener('pause', function () {
        try {
          if (player.pauseVideo) {
            player.pauseVideo();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('play-desktop', function () {
        if (!isTouch()) {
          playerWrapper.dispatchEvent(new Event('play'));
        }
      });
      playerWrapper.addEventListener('play', function () {
        try {
          if (player.playVideo) {
            player.playVideo();
          } else {
            player.addEventListener('onReady', function (event) {
              event.target.playVideo();
            });
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('destroy', function () {
        try {
          if (player.destroy) {
            player.destroy();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      return player;
    })
    .catch(function (err) {
      console.error(err);
    });
  return playerPromise;
}

window.youtubeLoaderPromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = function () {
    resolve();
  };
});
